<template>
  <!-- 积分中心 -->
  <div class="container">
    <Title-b :title="$t('Personal.Integralcenter')" />
    <div class="all">
      <div class="money">
        <div class="balance">
          <p>可消费积分</p>
          <p>{{ info.Money }}元</p>
        </div>
        <!-- &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -->
        <div class="consumption">
          <p>积分规则</p>
          <p>{{ rules }}</p>
        </div>
      </div>
    </div>

    <div class="date">
      <table id="table" cellspacing="0">
        <tr>
          <td>{{ $t("Personal.Integraltype") }}</td>
          <td>{{ $t("Myorder.Ordernumber") }}</td>
          <td>ID</td>
          <td>{{ $t("Personal.Integral") }}</td>
          <td>{{ $t("Personal.Time") }}</td>
        </tr>
        <tr v-for="(v, n) in data" :key="n">
          <td>{{ v.IntegralCome }}</td>
          <td>{{ v.OrderID }}</td>
          <td>{{ v.ID }}</td>
          <td>{{ v.Integral }}</td>
          <td>{{ v.CreateTime }}</td>
        </tr>
      </table>
    </div>
    <Page
      class="page-ive"
      :total="page.total"
      :current="1"
      :page-size="page.size"
      @on-change="changePage"
      show-total
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        MemberId: localStorage.getItem("userID"),
        offset: 1,
        limit: 10,
      },
      list: [],
      data: [],
      info: {},
      rules: "",
      page: {
        total: 1,
        current: 1, // 当前页码
        size: 8, // 每页个数
      },
    };
  },
  mounted() {
    this.queryIntegral();
  },
  methods: {
    async queryIntegral() {
      const { data } = await this.$post("QueryIntegral", this.form);
      if (data.State) {
        console.log(JSON.parse(data.ReturnJson));
        this.info = JSON.parse(data.ReturnJson);
        this.rules = JSON.parse(data.ReturnJson).IntegralRmk;
        this.info.QueryIntegralinfolist.forEach((item) => {
          this.list = this.list.concat(item.QueryIntegralinfo);
        });
        this.data = this.list;
        this.page.total = this.data.length;
        if (this.list.length < this.page.size) {
          this.data = this.list;
        } else {
          this.data = this.list.slice(0, this.pageSize);
        }
      }
    },
    changePage(index) {
      // 页码改变的回调，返回改变后的页码
      var _start = (index - 1) * this.page.size;
      var _end = index * this.page.size;
      this.data = this.list.slice(_start, _end);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 1069px;
  // height: 700px;
  background: #fff;
  border-radius: 5px;
  padding: 19px 17px;
  .all {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 20px 0 0 0px;
    .money {
      display: flex;
      flex-direction: row;
      text-align: center;
      justify-content: space-around;
      // width: 684px;
      width: 100%;
      .balance {
        width: 100%;
        height: 80px;
        background: #4141a0;
        cursor: pointer;
        p {
          line-height: 36px;
        }
        p:nth-child(1) {
          font-size: 16px;
          color: #fff;
        }
        p:nth-child(2) {
          font-size: 30px;
          color: #fff;
          font-weight: bold;
        }
      }
      .consumption {
        width: 100%;
        height: 80px;
        background: #4141a0;
        margin: 0 0 0 16px;
        p {
          line-height: 36px;
        }
        p:nth-child(1) {
          font-size: 16px;
          color: #fff;
        }
        p:nth-child(2) {
          font-size: 14px;
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
  .oneP {
    margin: 0 0 0 100px;
    font-size: 14px;
  }
  /deep/ #mygrid {
    // .ivu-table{
    //     border: 0px solid #fff;
    // }
    .ivu-table th {
      text-align: center;
      background: #fff;
      color: #000;
    }
    .ivu-table td {
      text-align: center;
    }
    .ivu-table .demo-table-info-row td {
      background-color: #f1f5fe;
      color: #666;
    }
  }
  // .p{
  //     padding: 19px 17px;
  //     color:#000;
  //     font-size: 16px;
  // }
  .background {
    background: url("../../../assets/images/kexiaofeijifen.png") no-repeat;
    margin: 10px 0 0 190px;
    width: 671px;
    height: 191px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .circular {
      text-align: center;
      line-height: 40px;
      width: 200px;
      height: 36px;
      background: #fbf1ae;
      border-radius: 15px;
      font-size: 30px;
      font-weight: bold;
      color: #ff9900;
      margin: 93px 0 0 0;
    }
  }
  .date {
    margin: 33px 0 0 0px;
    #table {
      width: 1029px;
      cursor: pointer;
      tr {
        height: 40px;
      }
      tr:nth-child(1) {
        @include backgroundColor($_color);
        // background: linear-gradient(0deg, #ff920a 0%, #ffaf4b 100%);
        font-size: 16px;
        color: #fff;
        td {
          color: #fff;
          font-size: 16px;
        }
      }
      td {
        width: 100px;
        font-size: 12px;
        text-align: center;
        border-bottom: 1px solid #ccc;
      }
      td:nth-child(1) {
        color: #ff9900;
        font-size: 12px;
      }
      .td:nth-child(even) {
        background: #fff;
      }
      .td:nth-child(odd) {
        background: #f1f5fe;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/view/user/Integralcenter.vue